// 공정 표준 Q&A(`0112`) — 화면에 가는 모양에는 org_id 가 없다(작성자는 「시공사 · 권역」 과 is_mine 만).

import type { QnaRegion } from "./region";

export const QNA_TOPICS = ["METHOD", "MATERIAL", "DEFECT", "WORKLOAD"] as const;
export type QnaTopic = (typeof QNA_TOPICS)[number];
export const QNA_TOPIC_LABEL: Record<QnaTopic, string> = { METHOD: "시공법", MATERIAL: "자재", DEFECT: "하자", WORKLOAD: "작업량" };

export const QNA_POST_KINDS = ["question", "answer"] as const;
export type QnaPostKind = (typeof QNA_POST_KINDS)[number];

export const QNA_REPORT_CATEGORIES = ["PRICE", "OTHER"] as const;
export type QnaReportCategory = (typeof QNA_REPORT_CATEGORIES)[number];
export const QNA_REPORT_CATEGORY_LABEL: Record<QnaReportCategory, string> = { PRICE: "가격 언급", OTHER: "기타" };

export const QNA_TITLE_MAX = 120;
export const QNA_BODY_MAX = 5000;
export const QNA_REASON_MAX = 500;
export const QNA_FEED_LIMIT = 50;

// 저장소 날것 행(인메모리·운영자용) — 멤버 화면에는 내보내지 않는다.
export interface QnaQuestionRow {
  id: string;
  org_id: string;
  topic: QnaTopic;
  title: string;
  body: string;
  region: QnaRegion | null;
  deleted_at: string | null;
  deleted_reason: string | null;
  created_at: string;
  updated_at: string;
}

export interface QnaAnswerRow {
  id: string;
  org_id: string;
  question_id: string;
  body: string;
  region: QnaRegion | null;
  deleted_at: string | null;
  deleted_reason: string | null;
  created_at: string;
  updated_at: string;
}

export interface QnaReportRow {
  id: string;
  org_id: string;
  post_kind: QnaPostKind;
  post_id: string;
  category: QnaReportCategory;
  reason: string | null;
  created_at: string;
}

// 멤버 화면 — 지운 글은 제목·본문 null.
export interface QnaQuestionView {
  id: string;
  topic: QnaTopic;
  title: string | null;
  body: string | null;
  region: QnaRegion | null;
  is_mine: boolean;
  answer_count: number;
  deleted: boolean;
  created_at: string;
  updated_at: string;
}

export interface QnaAnswerView {
  id: string;
  question_id: string;
  body: string | null;
  region: QnaRegion | null;
  is_mine: boolean;
  deleted: boolean;
  created_at: string;
  updated_at: string;
}

export interface QnaQuestionDetail {
  question: QnaQuestionView;
  answers: QnaAnswerView[];
}

// 쓰기 값 — id·권역은 앱이 정해 보낸다.
export interface QnaQuestionInsert {
  id: string;
  topic: QnaTopic;
  title: string;
  body: string;
  region: QnaRegion | null;
}

export interface QnaAnswerInsert {
  id: string;
  question_id: string;
  body: string;
  region: QnaRegion | null;
}

export interface QnaReportInsert {
  id: string;
  post_kind: QnaPostKind;
  post_id: string;
  category: QnaReportCategory;
  reason: string | null;
}

// 운영자 신고 목록 한 줄 — 글 하나에 신고를 모은다.
export interface QnaReportedPost {
  post_kind: QnaPostKind;
  post_id: string;
  question_id: string;
  question_title: string;
  body: string;
  org_id: string;
  org_name: string | null;
  region: QnaRegion | null;
  created_at: string;
  deleted_at: string | null;
  deleted_reason: string | null;
  report_count: number;
  category_counts: Record<QnaReportCategory, number>;
  reasons: string[];
  last_reported_at: string;
}

// 운영자 삭제 — 장부 전·후 값.
export interface QnaPostDeleteValues {
  post_kind: QnaPostKind;
  post_id: string;
  deleted_at: string | null;
  deleted_reason: string | null;
  // 질문 삭제 after 에만 — 같이 지운 답변 수(저장소가 잠금 아래서 센다 · `0113`).
  answers_deleted?: number;
}

export interface QnaPostDeleteSave {
  auditId: string;
  operatorId: string;
  actorEmail: string;
  postKind: QnaPostKind;
  postId: string;
  reason: string;
  before: QnaPostDeleteValues;
  after: QnaPostDeleteValues;
}
